import { render, staticRenderFns } from "./QuickViewContainer.vue?vue&type=template&id=10f0a552&scoped=true&"
import script from "./QuickViewContainer.js?vue&type=script&lang=js&"
export * from "./QuickViewContainer.js?vue&type=script&lang=js&"
import style0 from "./QuickViewContainer.scss?vue&type=style&index=0&id=10f0a552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../setup-pnpm/store/v11/links/@/vue-loader/15.10.2/4df48d78f583aab8cb7a79d5b07c76e21aa645336f56cb886eff36c580a62f81/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0a552",
  null
  
)

export default component.exports